<div class="clr-row nxm h-100" style="overflow: hidden">
  <div id="overlaySwitcher" [class.visible]="showOverlaySwitcher" [class.foreground]="filter_modal">
    <div class="clr-row" style="width: 100%; justify-content: flex-end">
      <button class="btn btn-sm btn-outline" (click)="reloadTopoJson()">
        <cds-icon shape="refresh" />
      </button>
    </div>
    @if (showOverlaySwitcher) {
      <div style="margin-top: -45px">
        <clr-dropdown>
          <button type="button" class="btn btn-icon dropdown-toggle" clrDropdownTrigger>
            <cds-icon shape="world" size="26" />
            <cds-icon shape="angle" direction="down" />
          </button>
          <clr-dropdown-menu *clrIfOpen>
            <a (click)="tileSwitch('sonstige', 'leer')" clrDropdownItem>{{ 'leer' | mrTranslate }}</a>
            <!--
            Bing hat seinen Dienst eingestellt.
            MR 2025-06-11
            -->
            <clr-dropdown>
              <button clrDropdownTrigger>Carto DB</button>
              <clr-dropdown-menu *clrIfOpen>
                <clr-dropdown>
                  <a (click)="tileSwitch('cartoDB', 'cartoDbDark')" clrDropdownItem>Dark</a>
                  <a (click)="tileSwitch('cartoDB', 'cartoDbDarkNoLabels')" clrDropdownItem>Dark no Label</a>
                  <a (click)="tileSwitch('cartoDB', 'cartoDbLight')" clrDropdownItem>Light</a>
                  <a (click)="tileSwitch('cartoDB', 'cartoDbLightNoLabels')" clrDropdownItem>Light no Label</a>
                </clr-dropdown>
              </clr-dropdown-menu>
            </clr-dropdown>
            <clr-dropdown>
              <button clrDropdownTrigger>ESRI</button>
              <clr-dropdown-menu *clrIfOpen>
                <clr-dropdown>
                  <a (click)="tileSwitch('sonstige', 'esri')" clrDropdownItem>Hybrid</a>
                </clr-dropdown>
              </clr-dropdown-menu>
            </clr-dropdown>
            <clr-dropdown>
              <button clrDropdownTrigger>{{ 'Geoportale' | mrTranslate }}</button>
              <clr-dropdown-menu *clrIfOpen>
                <clr-dropdown>
                  <button clrDropdownTrigger>{{ 'Belgien' | mrTranslate }}</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('sonstige', 'belgiumOrtho')" clrDropdownItem>Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'belgiumCarto')" clrDropdownItem>Carto.be</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <clr-dropdown>
                  <button clrDropdownTrigger>{{ 'Deutschland' | mrTranslate }}</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('sonstige', 'bb_house')" clrDropdownItem>{{ 'BB ALKIS Gebäude' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'bb_lands')" clrDropdownItem>{{ 'BB ALKIS Flurstücke' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'bb_ortho')" clrDropdownItem>BB Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'bw_ortho')" clrDropdownItem>BW Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'by_ortho')" clrDropdownItem>BY Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'hb_ortho')" clrDropdownItem>HB Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'he_ortho')" clrDropdownItem>HE Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'hh_ortho')" clrDropdownItem>HH Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'mv_house')" clrDropdownItem>{{ 'MV ALKIS Gebäude' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'mv_lands')" clrDropdownItem>{{ 'MV ALKIS Flurstücke' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'mv_ortho')" clrDropdownItem>MV Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'ni_ortho')" clrDropdownItem>NI Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'nrw_house')" clrDropdownItem>{{ 'NR ALKIS Gebäude' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'nrw_lands')" clrDropdownItem>{{ 'NR ALKIS Flurstücke' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'nrwOrtho')" clrDropdownItem>NR Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'rp_ortho')" clrDropdownItem>RP Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'sa_ortho')" clrDropdownItem>SA Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'sn_house')" clrDropdownItem>{{ 'SN ALKIS Gebäude' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'sn_lands')" clrDropdownItem>{{ 'SN ALKIS Flurstücke' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'sn_ortho')" clrDropdownItem>SN Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'th_ortho')" clrDropdownItem>TH Ortho</a>
                      <a (click)="tileSwitch('sonstige', 'de_farbe')" clrDropdownItem>BASEMAP.DE</a>
                      <a (click)="tileSwitch('sonstige', 'de_grau')" clrDropdownItem>{{ 'BASEMAP.DE grau' | mrTranslate }}</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <clr-dropdown>
                  <button clrDropdownTrigger>{{ 'Luxemburg' | mrTranslate }}</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('sonstige', 'luxBaseMap')" clrDropdownItem>Basemap</a>
                      <a (click)="tileSwitch('sonstige', 'luxOrtho')" clrDropdownItem>Ortho</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <clr-dropdown>
                  <button clrDropdownTrigger>{{ 'Österreich' | mrTranslate }}</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('sonstige', 'austriaOrtho')" clrDropdownItem>{{ 'Österreich Ortho' | mrTranslate }}</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <clr-dropdown>
                  <button clrDropdownTrigger>{{ 'Schweiz' | mrTranslate }}</button>
                  <clr-dropdown-menu *clrIfOpen>
                    <clr-dropdown>
                      <a (click)="tileSwitch('sonstige', 'ch_base')" clrDropdownItem>{{ 'Swisstopo Pixelkarte farbe' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'ch_base_grau')" clrDropdownItem>{{ 'Swisstopo Pixelkarte grau' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'ch_ortho')" clrDropdownItem>{{ 'Swisstopo Ortho' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'ch_bs_ortho')" clrDropdownItem>{{ 'Basel-Stadt Ortho' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'ch_bs_color')" clrDropdownItem>{{ 'Basel Grundkarten farbig' | mrTranslate }}</a>
                      <a (click)="tileSwitch('sonstige', 'ch_bs_sw')" clrDropdownItem>{{ 'Basel Grundkarte schwarz-weiss' | mrTranslate }}</a>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
              </clr-dropdown-menu>
            </clr-dropdown>
            <clr-dropdown>
              <button clrDropdownTrigger>Google</button>
              <clr-dropdown-menu *clrIfOpen>
                <clr-dropdown>
                  <a (click)="tileSwitch('google', 'googleMaps')" clrDropdownItem>GoogleMaps</a>
                  <a (click)="tileSwitch('google', 'googleSatellite')" clrDropdownItem>{{ 'Satelit' | mrTranslate }}</a>
                  <a (click)="tileSwitch('google', 'googleHybrid')" clrDropdownItem>Hybrid</a>
                  <a (click)="tileSwitch('google', 'googleTerrain')" clrDropdownItem>Terrain</a>
                </clr-dropdown>
              </clr-dropdown-menu>
            </clr-dropdown>
            <clr-dropdown>
              <button clrDropdownTrigger>Openstreetmap</button>
              <clr-dropdown-menu *clrIfOpen>
                <clr-dropdown>
                  <a (click)="tileSwitch('sonstige', 'osmde')" clrDropdownItem>Openstreetmap</a>
                  <a (click)="tileSwitch('sonstige', 'openrailwaymap')" clrDropdownItem>OpenRailwayMap</a>
                </clr-dropdown>
              </clr-dropdown-menu>
            </clr-dropdown>
            <a (click)="tileSwitch('sonstige', 'wikimedia')" clrDropdownItem>WikiMaps</a>
          </clr-dropdown-menu>
        </clr-dropdown>
      </div>
    }

    @if (overLayers) {
      <div style="margin-top: 10px">
        <strong>{{ 'Allgemein' | mrTranslate }}</strong>
        <clr-accordion>
          <clr-accordion-panel>
            <clr-accordion-title>{{ 'Objekte' | mrTranslate }}</clr-accordion-title>
            <clr-accordion-content *clrIfExpanded>
              <clr-tree id="baseOverlayTree">
                <clr-tree-node
                  [clrExpanded]="true"
                  [clrSelected]="true"
                  (clrSelectedChange)="selectAlleObjekte($event)">
                  {{ 'Alle' | mrTranslate }}
                  @for (overlay of overLayers.base[0].overlays; track overlay; let j = $index) {
                    <clr-tree-node
                      [clrSelected]="overlay.enable"
                      [clrDisabled]="tempDisable"
                      (clrSelectedChange)="changeOverlayState('base', 0, j, $event)">
                      <span class="span-tree-node">
                        <cds-icon
                          [shape]="'objekttyp' + overlay.icon"
                          size="18"
                          style="color: black; margin-right: 0.4em"></cds-icon>
                        {{ overlay.name }}
                      </span>
                    </clr-tree-node>
                  }
                </clr-tree-node>
              </clr-tree>
            </clr-accordion-content>
          </clr-accordion-panel>
          @if (!isRep) {
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Kartenset' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <clr-select-container>
                  <label>Set</label>
                  <select
                    clrSelect
                    name="options"
                    #selMapSet
                    id="selMapSet"
                    [(ngModel)]="curMapSet"
                    (change)="changeMapSet()">
                    @for (objlist of tblKartenset.rows; track objlist) {
                      <option value="{{ objlist.ID }}">
                        {{ objlist.Dateiname }}
                      </option>
                    }
                  </select>
                </clr-select-container>
                <br />
                <div class="btn-group btn-icon">
                  <button
                    class="btn btn-icon"
                    id="btnSetAdd"
                    (click)="isMapSetNameVisible = true; isnewMapSet = true"
                    title="{{ 'Neues Kartenset erstellen' | mrTranslate }}">
                    <cds-icon shape="plus" size="32" />
                  </button>
                  <button
                    class="btn btn-icon"
                    id="btnSetEdit"
                    (click)="isMapSetNameVisible = true; isnewMapSet = false"
                    title="{{ 'Name bearbeiten' | mrTranslate }}">
                    <cds-icon shape="pencil" size="32" />
                  </button>
                  <button
                    class="btn btn-icon"
                    id="btnSetDelete"
                    (click)="deleteMapSet()"
                    title="{{ 'Kartenset löschen' | mrTranslate }}">
                    <cds-icon shape="delete" size="32" />
                  </button>
                </div>
              </clr-accordion-content>
            </clr-accordion-panel>
          }
          <clr-accordion-panel>
            <clr-accordion-title>{{ 'Farben' | mrTranslate }}</clr-accordion-title>
            <clr-accordion-content *clrIfExpanded>
              <cds-icon
                shape="circle"
                solid="true"
                class="cursor-pointer"
                [ngStyle]="{ color: baseColor }"
                [(colorPicker)]="baseColor"
                (colorPickerChange)="setColorGeneral('baseColor', $event)" />
              <span [title]="'Hauptfarbe' | mrTranslate">{{ 'Linienfarbe' | mrTranslate }}</span>
              <br />
              <cds-icon
                shape="circle"
                solid="true"
                class="cursor-pointer"
                [ngStyle]="{ color: hoverColor }"
                [(colorPicker)]="hoverColor"
                (colorPickerChange)="setColorGeneral('hoverColor', $event)" />
              <span [title]="'Hauptfarbe' | mrTranslate">{{ 'Auswahl-Farbe (Objekt verknüpft)' | mrTranslate }}</span>
              <br />
              <cds-icon
                shape="circle"
                solid="true"
                class="cursor-pointer"
                [ngStyle]="{ color: hoverEmptyColor }"
                [(colorPicker)]="hoverEmptyColor"
                (colorPickerChange)="setColorGeneral('hoverEmptyColor', $event)" />
              <span [title]="'Hauptfarbe' | mrTranslate">
                {{ 'Auswahl-Farbe (Objekt nicht verknüpft)' | mrTranslate }}
              </span>
              <br />
              <br />
              <div class="btn-group btn-icon">
                <button class="btn" (click)="resetColor()" title="{{ 'zurücksetzen' | mrTranslate }}">
                  <cds-icon shape="undo" size="32" />
                </button>
              </div>
            </clr-accordion-content>
          </clr-accordion-panel>
        </clr-accordion>
      </div>
    }
    @if (overLayers && !isRep) {
      <div style="margin-top: 30px">
        <div
          style="width: 0px; position: absolute; top: 50%"
          [(colorPicker)]="ol.color"
          [style.background]="baseColor"
          (colorPickerChange)="setColorFromPicker(ol.key, ol.i, ol.j, $event)"
          (cpToggleChange)="leaveColorFocus($event)"
          #colorIn></div>
        <strong>{{ 'Visualisierung' | mrTranslate }}</strong>
        <clr-accordion>
          <clr-accordion-panel>
            <clr-accordion-title>{{ 'Zustand' | mrTranslate }}</clr-accordion-title>
            <clr-accordion-content *clrIfExpanded>
              <ng-container *ngTemplateOutlet="zustandAccordion" />
            </clr-accordion-content>
          </clr-accordion-panel>
          @if (overLayers.visualisations['bauform']) {
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Bauform' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <ng-container *ngTemplateOutlet="bauformAccordion" />
              </clr-accordion-content>
            </clr-accordion-panel>
          }
          <clr-accordion-panel>
            <clr-accordion-title>{{ 'Stammdaten' | mrTranslate }}</clr-accordion-title>
            <clr-accordion-content *clrIfExpanded>
              <ng-container *ngTemplateOutlet="stammdatenAccordion" />
            </clr-accordion-content>
          </clr-accordion-panel>
          @if (overLayers.visualisations['hersteller']) {
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Hersteller' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <ng-container *ngTemplateOutlet="herstellerAccordion" />
              </clr-accordion-content>
            </clr-accordion-panel>
          }
          @if (overLayers.visualisations['prueftermin']) {
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Termin' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <ng-container *ngTemplateOutlet="terminAccordion" />
              </clr-accordion-content>
            </clr-accordion-panel>
          }
          @if (overLayers.visualisations['projekte']) {
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Projekte' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <ng-container *ngTemplateOutlet="projekteAccordion" />
              </clr-accordion-content>
            </clr-accordion-panel>
          }
          <clr-accordion-panel>
            <clr-accordion-title>{{ 'Anzeigeoptionen' | mrTranslate }}</clr-accordion-title>
            <clr-accordion-content *clrIfExpanded>
              <ng-container *ngTemplateOutlet="showAccordion" />
            </clr-accordion-content>
          </clr-accordion-panel>
        </clr-accordion>
        <ng-template #zustandAccordion>
          <clr-accordion>
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Fehlerklassen einfach' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <clr-tree>
                  <clr-tree-node>
                    {{ 'Alle' | mrTranslate }}
                    @for (overlay of overLayers.base[1].overlays; track overlay; let j = $index) {
                      <clr-tree-node
                        [clrSelected]="overlay.enable"
                        (clrSelectedChange)="changeOverlayState('base', 1, j, $event)">
                        <span class="span-tree-node">
                          <cds-icon shape="circle" solid="true" [ngStyle]="{ color: overlay.color }" />
                          <span [attr.title]="overlay.name">{{ overlay.name | dotDotDot: 30 }}</span>
                        </span>
                      </clr-tree-node>
                    }
                  </clr-tree-node>
                </clr-tree>
              </clr-accordion-content>
            </clr-accordion-panel>
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Fehlerklassen segmentiert' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <clr-tree>
                  <clr-tree-node>
                    {{ 'Alle' | mrTranslate }}
                    @for (overlay of overLayers.base[2].overlays; track overlay; let j = $index) {
                      <clr-tree-node
                        [clrSelected]="overlay.enable"
                        [clrDisabled]="tempDisable"
                        (clrSelectedChange)="changeOverlayState('base', 2, j, $event)">
                        <cds-icon shape="circle" solid="true" [ngStyle]="{ color: overlay.color }" />
                        <span [attr.title]="overlay.name">{{ overlay.name | dotDotDot: 30 }}</span>
                      </clr-tree-node>
                    }
                  </clr-tree-node>
                </clr-tree>
                @if (sqlfilter.length == 0) {
                  <div>
                    <div style="min-height: 5px"></div>
                    <button class="btn btn-primary btn-sm" (click)="initFilter()">
                      {{ 'Filter' | mrTranslate }}
                    </button>
                  </div>
                } @else {
                  <div style="min-height: 5px"></div>
                  <span>{{ 'aktiver Filter' | mrTranslate }}:</span>
                  <br />
                  @for (item of sqlfilter; track item) {
                    <span class="label label-info" style="min-height: 28px">
                      {{ item.sql }}
                      <cds-icon
                        shape="times"
                        class="cursor-pointer"
                        (click)="delete(item)"
                        style="margin-left: 0.5rem; margin-right: -0.25rem" />
                    </span>
                  }
                }
              </clr-accordion-content>
            </clr-accordion-panel>
            @for (overlayCat of overLayers.visualisations['stoerungen']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ 'Störungen' | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('stoerungen', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
            @for (overlayCat of overLayers.visualisations['sperrungen']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ overlayCat.category | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('sperrungen', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
            @for (overlayCat of overLayers.visualisations['langsamfahrstellen']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ overlayCat.category | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('langsamfahrstellen', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
            @for (overlayCat of overLayers.visualisations['auftraege']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ 'Aufträge' | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('auftraege', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
            @if (overLayers.visualisations['kaveinfach']) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ 'KAV' | mrTranslate }} {{ 'Einfach' | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  @for (overlayCat of overLayers.visualisations['kaveinfach']; track overlayCat; let i = $index) {
                    <app-overlay-select-search
                      [overlays]="overlayCat.overlays"
                      (colorChange)="colorChanged($event)"
                      (selectedChange)="changeOverlayState('kaveinfach', i, $event.index, $event.selected)" />
                  }
                </clr-accordion-content>
              </clr-accordion-panel>
            }
            @if (overLayers.visualisations['kavseg']) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ 'KAV' | mrTranslate }} {{ 'Segmentiert' | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <clr-accordion>
                    @for (overlayCat of overLayers.visualisations['kavseg']; track overlayCat; let i = $index) {
                      <clr-accordion-panel>
                        <clr-accordion-title>
                          {{ overlayCat.category | mrTranslate }}
                        </clr-accordion-title>
                        <clr-accordion-content *clrIfExpanded>
                          <app-overlay-select-search
                            [overlays]="overlayCat.overlays"
                            (colorChange)="colorChanged($event)"
                            (selectedChange)="changeOverlayState('kavseg', i, $event.index, $event.selected)" />
                        </clr-accordion-content>
                      </clr-accordion-panel>
                    }
                  </clr-accordion>
                </clr-accordion-content>
              </clr-accordion-panel>
            }
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Auswertung Gleismessdaten' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <app-gleismessdatenmodal
                  (mess_filter)="setMessFilter($event)"
                  [resultReady]="isGleisMessFilterReady"></app-gleismessdatenmodal>
              </clr-accordion-content>
            </clr-accordion-panel>
            @if (hasrailprofiles == true) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ 'Auswertung Schienenprofile' | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <div class="clr-row" style="margin-top: 10px">
                    <div class="clr-col">
                      <div>
                        {{ 'Abfräsung pro Überfahrt [mm]' | mrTranslate }}
                      </div>
                      <ngx-slider
                        [(value)]="vauleGrinding"
                        [options]="optionsGrinding"
                        (mouseup)="sliderGrindingEvent()"></ngx-slider>
                      <div>
                        {{ 'minimale Abweichung zu Soll-Profil [mm]' | mrTranslate }}
                      </div>
                      <ngx-slider
                        [(value)]="vauleWare"
                        [options]="optionsWare"
                        (mouseup)="sliderWareEvent()"></ngx-slider>
                      <div>
                        {{ 'Bearbeitungsgeschwindigkeit [m/min]' | mrTranslate }}
                      </div>
                      <ngx-slider
                        [(value)]="vauleGrindingSpeed"
                        [options]="optionsGrindingSpeed"
                        (mouseup)="sliderGrindingSpeedEvent()"></ngx-slider>
                      @if (sumAnzahl == -1) {
                        <button type="button" class="btn btn-sm btn-primary" (click)="setFilterSchienenprofile(true)">
                          {{ 'Filter übernehmen' | mrTranslate }}
                        </button>
                      }
                      @if (sumAnzahl != -1) {
                        <div>
                          {{ 'Summe der Überfahrten' | mrTranslate }}:
                          {{ sumAnzahl }}
                        </div>
                      }
                      @if (sumLenght != -1) {
                        <div>{{ 'Bearbeitungslänge' | mrTranslate }}: {{ sumLenght }} {{ 'm' }}</div>
                      }
                      @if (sumLenght != -1) {
                        <div>
                          {{ 'Bearbeitungszeit' | mrTranslate }}:
                          {{ this.strTime }}
                        </div>
                      }
                    </div>
                  </div>
                  @if (railprofilesOverlays?.length) {
                    <app-overlay-select-search
                      [overlays]="railprofilesOverlays"
                      [labelTemplate]="labelRailProfil"
                      (colorChange)="colorChanged($event)"
                      (selectedChange)="changeOverlayState('railprofiles', 0, $event.index, $event.selected)" />
                    <ng-template #labelRailProfil let-overlay="overlay">
                      {{ overlay.val }} {{ 'Überfahrten' | mrTranslate }}
                    </ng-template>
                  }
                </clr-accordion-content>
              </clr-accordion-panel>
            }
          </clr-accordion>
        </ng-template>
        <ng-template #bauformAccordion>
          <clr-accordion>
            @for (overlayCat of overLayers.visualisations['bauform']; track overlayCat; let i = $index) {
              <clr-accordion-panel (clrAccordionPanelOpenChange)="panelBauformChange($event, overlayCat)">
                <clr-accordion-title>{{ overlayCat.category | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('bauform', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
          </clr-accordion>
        </ng-template>
        <ng-template #stammdatenAccordion>
          <clr-accordion>
            @for (overlayCat of overLayers.visualisations['stamm']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ correctStammName(overlayCat.category) | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('stamm', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
            @for (overlayCat of overLayers.visualisations['trassierungen']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ 'Trassierungen' | mrTranslate }} {{ overlayCat.category }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('trassierungen', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
          </clr-accordion>
        </ng-template>
        <ng-template #herstellerAccordion>
          <clr-accordion>
            @for (overlayCat of overLayers.visualisations['hersteller']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ overlayCat.category | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('hersteller', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
          </clr-accordion>
        </ng-template>
        <ng-template #terminAccordion>
          <clr-accordion>
            @for (overlayCat of overLayers.visualisations['prueftermin']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ 'Prüftermin' | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('prueftermin', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
            @for (overlayCat of overLayers.visualisations['termin']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ overlayCat.category + ' überschritten' | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('termin', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
          </clr-accordion>
        </ng-template>
        <ng-template #projekteAccordion>
          <clr-accordion>
            @for (overlayCat of overLayers.visualisations['projekte']; track overlayCat; let i = $index) {
              <clr-accordion-panel>
                <clr-accordion-title>{{ overlayCat.category | mrTranslate }}</clr-accordion-title>
                <clr-accordion-content *clrIfExpanded>
                  <app-overlay-select-search
                    [overlays]="overlayCat.overlays"
                    (colorChange)="colorChanged($event)"
                    (selectedChange)="changeOverlayState('projekte', i, $event.index, $event.selected)" />
                </clr-accordion-content>
              </clr-accordion-panel>
            }
          </clr-accordion>
        </ng-template>
        <ng-template #showAccordion>
          <clr-accordion>
            <clr-checkbox-wrapper class="map-option-check">
              <label>{{ 'Objektbezeichnung anzeigen' | mrTranslate }}</label>
              <input type="checkbox" clrCheckbox value="1" (click)="setObjText($event)" />
            </clr-checkbox-wrapper>
            <clr-checkbox-wrapper class="map-option-check">
              <label>{{ 'Mangelbemerkungen anzeigen' | mrTranslate }}</label>
              <input type="checkbox" clrCheckbox value="1" (click)="setMangelBem($event)" />
            </clr-checkbox-wrapper>
            <clr-checkbox-wrapper class="map-option-check">
              <label>{{ 'Standort anzeigen' | mrTranslate }}</label>
              <input type="checkbox" clrCheckbox value="1" (click)="showPosition($event)" />
            </clr-checkbox-wrapper>
          </clr-accordion>
        </ng-template>
        <br />
        @if (canEdit) {
          <strong>{{ 'Editor' | mrTranslate }}</strong>
          <clr-accordion clrAccordionMultiPanel="true">
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Allgemein' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <label style="font-size: 12px; font-weight: bolder">
                  {{ 'Bearbeiten' | mrTranslate }}
                </label>
                <br />
                <div class="btn-group btn-icon">
                  <button
                    type="button"
                    class="btn btn-icon"
                    id="btnDelete"
                    (click)="deleteSelected()"
                    title="{{ 'Objekt löschen' | mrTranslate }}">
                    <cds-icon shape="delete" size="32" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    id="btnModify"
                    [disabled]="!activeElement"
                    (click)="modifySelected($event)"
                    title="{{ 'Objekt bearbeiten' | mrTranslate }}">
                    <cds-icon shape="cursor-hand-grab" size="32" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    id="btnUpdate"
                    [disabled]="!activeElement"
                    (click)="updateSelected($event)"
                    title="{{ 'Objekt einer Anlage zuweisen' | mrTranslate }}">
                    <cds-icon shape="pencil" size="32" />
                  </button>
                </div>
                <br />
                <br />
                <label style="font-size: 12px; font-weight: bolder">
                  {{ 'Schneiden/Trennen' | mrTranslate }}
                </label>
                <br />
                <div class="btn-group btn-icon">
                  <button
                    type="button"
                    class="btn btn-icon"
                    id="btnCut"
                    [disabled]="!activeElement"
                    (click)="cutSelected($event)"
                    title="{{ 'Linie abschneiden' | mrTranslate }}">
                    <cds-icon shape="trimLine" size="32" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    id="btnCutPos"
                    [disabled]="!activeElement"
                    (click)="cutSelectedAtPos($event)"
                    title="{{ 'Linie abschneiden bei Position' | mrTranslate }}">
                    <cds-icon shape="trimLineAtPos" size="32" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    id="btnSep"
                    [disabled]="!activeElement"
                    (click)="separateSelected($event)"
                    title="{{ 'Linie trennen' | mrTranslate }}">
                    <cds-icon shape="breakLine" size="32" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    id="btnSepPos"
                    [disabled]="!activeElement"
                    (click)="separateSelectedAtPos($event)"
                    title="{{ 'Linie trennen' | mrTranslate }}">
                    <cds-icon shape="breakLineAtPos" size="32" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    id="btnMerge"
                    [disabled]="!activeElement"
                    (click)="mergeSelected($event)"
                    title="{{ 'Linien verbinden' | mrTranslate }}">
                    <cds-icon shape="mergeLine" size="32" />
                  </button>
                </div>
                <br />
                <br />
                <label style="font-size: 12px; font-weight: bolder">
                  {{ 'Sortieren' | mrTranslate }}
                </label>
                <br />
                <div class="btn-group btn-icon">
                  <button
                    type="button"
                    class="btn btn-icon"
                    [disabled]="!activeElement"
                    (click)="sortLine($event)"
                    title="{{ 'Linie sortieren' | mrTranslate }}">
                    <cds-icon shape="sortLine" size="32" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    [disabled]="!activeElement"
                    (click)="setRotateLine($event)"
                    title="{{ 'Linie drehen' | mrTranslate }}">
                    <cds-icon shape="rotateLine" size="32" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    id="btnUpdate"
                    [disabled]="!activeElement"
                    (click)="setToBackground(0)"
                    title="{{ 'Objekt in den Hintergrund schieben' | mrTranslate }}">
                    <cds-icon shape="toBackground" size="32" />
                  </button>
                </div>
                <br />
                <br />
                <label style="font-size: 12px; font-weight: bolder">
                  {{ 'Messung' | mrTranslate }}
                </label>
                <br />
                <div class="btn-group btn-icon">
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="setMeasure($event)"
                    title="{{ 'Distanz zwischen zwei Punkten ermitteln' | mrTranslate }}">
                    <cds-icon shape="ruler" size="30" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="getPos($event)"
                    title="{{ 'Position ermitteln' | mrTranslate }}">
                    <cds-icon shape="pin" size="30" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="startDrawArc(true, $event)"
                    title="{{ 'Radius messen' | mrTranslate }}">
                    <cds-icon shape="arcCalc" size="30" />
                  </button>
                  <!-- <button class="btn-icon" (click)="setMoveAll($event)" title="{{'Alles bewegen' | mrTranslate}}"><cds-icon shape="ruler" size="32"/></button> -->
                </div>
                <br />
                <br />
                <label style="font-size: 12px; font-weight: bolder">
                  {{ 'Bereinigen' | mrTranslate }}
                </label>
                <br />
                <div class="btn-group btn-icon">
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="reloadTopoJson(1)"
                    title="{{ 'Komplette Map doppelte Elemente entfernen' | mrTranslate }}">
                    <cds-icon shape="recycle" size="30" />
                    @if (isloadRecycle) {
                      <span class="spinner spinner-sm">Loading...</span>
                    }
                  </button>
                </div>
                <br />
                <br />
                <label style="font-size: 12px; font-weight: bolder">
                  {{ 'Linienbelegung zuordnen' | mrTranslate }}
                </label>
                <br />
                <clr-select-container style="display: inline-block">
                  <select clrSelect [(ngModel)]="selectedLinienForObject">
                    <option [value]="undefined" disabled selected>
                      {{ 'Linie auswählen' | mrTranslate }}
                    </option>
                    @for (line of linieeorginal; track line) {
                      <option [ngValue]="+line.ID">
                        {{ line.Nummer + ' - ' + line.Ort }}
                      </option>
                    }
                  </select>
                </clr-select-container>
                <br />
                <button
                  [disabled]="_ostammid == undefined || _selectedLinienForObject == undefined"
                  type="button"
                  class="btn btn-icon"
                  (click)="addLine()"
                  title="{{ 'Linienbelegung zuordnen' | mrTranslate }}">
                  <cds-icon shape="plus" size="30" />
                </button>
                @if (clickSelectLenght !== undefined) {
                  <div>{{ 'Länge' | mrTranslate }}: {{ clickSelectLenght }}</div>
                } @else {
                  <div>{{ 'Länge' | mrTranslate }}: NaN</div>
                }
              </clr-accordion-content>
            </clr-accordion-panel>
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Zeichnen' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <div class="btn-group btn-icon">
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="startDraw('LineString', $event)"
                    title="{{ 'Linie zeichnen' | mrTranslate }}">
                    <cds-icon shape="draw_line" size="30" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="startDrawArc(false, $event)"
                    title="{{ 'Bogen' | mrTranslate }}">
                    <cds-icon shape="draw_arc" size="30" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="startDraw('Polygon', $event)"
                    title="{{ 'Fläche' | mrTranslate }}">
                    <cds-icon shape="draw_area" size="30" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="startPlaceSymbol(0, $event)"
                    title="{{ 'Punktsymbol platzieren' | mrTranslate }}">
                    <cds-icon shape="styp0" size="30" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="startDraw('None', $event)"
                    title="{{ 'Abbrechen' | mrTranslate }}">
                    <cds-icon shape="cursor-arrow" size="30" />
                  </button>
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="undoDraw()"
                    title="{{ 'Letzte Linie zurücksetzen' | mrTranslate }}">
                    <cds-icon shape="undo" size="30" />
                  </button>
                </div>
                <br />
                <br />
                <button
                  type="button"
                  class="btn btn-icon"
                  (click)="showTOEditor()"
                  title="{{ 'Weichen-Editor' | mrTranslate }}">
                  <cds-icon shape="weicheneditor" size="30" />
                </button>
              </clr-accordion-content>
            </clr-accordion-panel>
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Symbole' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <clr-accordion>
                  <div class="btn-group btn-icon">
                    <button
                      type="button"
                      class="btn btn-icon"
                      id="btnRotate"
                      [disabled]="!activeElement"
                      (click)="rotateSymbol($event)"
                      title="{{ 'Objekt drehen' | mrTranslate }}">
                      <cds-icon shape="rotateObj" size="30" />
                    </button>
                    <button
                      type="button"
                      class="btn btn-icon"
                      id="btnMove"
                      [disabled]="!activeElement"
                      (click)="moveSymbol($event)"
                      title="{{ 'Objekt bewegen' | mrTranslate }}">
                      <cds-icon shape="cursor-move" size="30" />
                    </button>
                  </div>
                  <clr-accordion-panel>
                    <clr-accordion-title>{{ 'Gleissperren' | mrTranslate }}</clr-accordion-title>
                    <clr-accordion-content *clrIfExpanded>
                      <div class="btn-group btn-icon" style="display: flow">
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(1, $event)"
                          title="{{ 'Gleissperre links' | mrTranslate }}">
                          <cds-icon shape="styp1" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(2, $event)"
                          title="{{ 'Gleissperre rechts' | mrTranslate }}">
                          <cds-icon shape="styp2" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(47, $event)"
                          title="{{ 'Gleissperre zweiseitig' | mrTranslate }}">
                          <cds-icon shape="styp47" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(3, $event)"
                          title="{{ 'Gleissperre links ferngesteuert' | mrTranslate }}">
                          <cds-icon shape="styp3" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(4, $event)"
                          title="{{ 'Gleissperre rechts ferngesteuert' | mrTranslate }}">
                          <cds-icon shape="styp4" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(48, $event)"
                          title="{{ 'Gleissperre zweiseitig ferngesteuert' | mrTranslate }}">
                          <cds-icon shape="styp48" size="30" />
                        </button>
                      </div>
                    </clr-accordion-content>
                  </clr-accordion-panel>
                  <clr-accordion-panel>
                    <clr-accordion-title>{{ 'Isolierstöße' | mrTranslate }}</clr-accordion-title>
                    <clr-accordion-content *clrIfExpanded>
                      <div class="btn-group btn-icon" style="display: flow">
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(5, $event)"
                          title="{{ 'Isolierstoß' | mrTranslate }}">
                          <cds-icon shape="styp5" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(30, $event)"
                          title="{{ 'Isolierstoß nach beiden Seiten' | mrTranslate }}">
                          <cds-icon shape="styp30" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(31, $event)"
                          title="{{ 'Isolierstoß nach rechts wirkend' | mrTranslate }}">
                          <cds-icon shape="styp31" size="30" />
                        </button>
                      </div>
                    </clr-accordion-content>
                  </clr-accordion-panel>
                  <clr-accordion-panel>
                    <clr-accordion-title>{{ 'Lichtsignale' | mrTranslate }}</clr-accordion-title>
                    <clr-accordion-content *clrIfExpanded>
                      <div class="btn-group btn-icon" style="display: flow">
                        <button
                          type="button"
                          class="btn btn-icon"
                          style="width: 50px"
                          (click)="startPlaceSymbol(14, $event)"
                          title="{{ 'Lichthauptsignal' | mrTranslate }}">
                          <cds-icon shape="styp14" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          style="width: 50px"
                          (click)="startPlaceSymbol(15, $event)"
                          title="{{ 'Lichthauptsignal mit Geschwindigkeitsanzeiger' | mrTranslate }}">
                          <cds-icon shape="styp15" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          style="width: 50px"
                          (click)="startPlaceSymbol(16, $event)"
                          title="{{ 'Lichthauptsignal mit Geschwindigkeitsanzeiger und Voranzeiger' | mrTranslate }}">
                          <cds-icon shape="styp16" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          style="width: 50px"
                          (click)="startPlaceSymbol(17, $event)"
                          title="{{ 'Lichtvorsignal' | mrTranslate }}">
                          <cds-icon shape="styp17" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          style="width: 50px"
                          (click)="startPlaceSymbol(18, $event)"
                          title="{{ 'Lichtvorsignal mit Geschwindigkeitsanzeiger' | mrTranslate }}">
                          <cds-icon shape="styp18" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          style="width: 50px"
                          (click)="startPlaceSymbol(19, $event)"
                          title="{{ 'Lichthauptsignal als Mehrabschnittssignal' | mrTranslate }}">
                          <cds-icon shape="styp19" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          style="width: 50px"
                          (click)="startPlaceSymbol(20, $event)"
                          title="{{
                            'Lichthauptsignal als Mehrabschnittssignal mit Geschwindigkeitsanzeiger' | mrTranslate
                          }}">
                          <cds-icon shape="styp20" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          style="width: 50px"
                          (click)="startPlaceSymbol(21, $event)"
                          title="{{
                            'Lichthauptsignal als Mehrabschnittssignal mit Geschwindigkeitsvoranzeiger' | mrTranslate
                          }}">
                          <cds-icon shape="styp21" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          style="width: 50px"
                          (click)="startPlaceSymbol(22, $event)"
                          title="{{
                            'Lichthauptsignal als Mehrabschnittssignal mit Geschwindigkeitsanzeiger / voranzeiger'
                              | mrTranslate
                          }}">
                          <cds-icon shape="styp22" size="30" />
                        </button>
                      </div>
                    </clr-accordion-content>
                  </clr-accordion-panel>
                  <clr-accordion-panel>
                    <clr-accordion-title>{{ 'Radsensoren' | mrTranslate }}</clr-accordion-title>
                    <clr-accordion-content *clrIfExpanded>
                      <div class="btn-group btn-icon" style="display: flow">
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(23, $event)"
                          title="{{ 'Achszählkontakt' | mrTranslate }}">
                          <cds-icon shape="styp23" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(32, $event)"
                          title="{{ 'Schaltkontakt' | mrTranslate }}">
                          <cds-icon shape="styp32" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(33, $event)"
                          title="{{ 'Bü-Schaltkontakt' | mrTranslate }}">
                          <cds-icon shape="styp33" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(34, $event)"
                          title="{{ 'Magnetschienenkontakt' | mrTranslate }}">
                          <cds-icon shape="styp34" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(35, $event)"
                          title="{{ 'Fahrzeugsensor' | mrTranslate }}">
                          <cds-icon shape="styp35" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(36, $event)"
                          title="{{ 'Schaltbarer Gleismagnet' | mrTranslate }}">
                          <cds-icon shape="styp36" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(37, $event)"
                          title="{{ 'Ständig wirksame Gleismagnete' | mrTranslate }}">
                          <cds-icon shape="styp37" size="30" />
                        </button>
                      </div>
                    </clr-accordion-content>
                  </clr-accordion-panel>
                  <clr-accordion-panel>
                    <clr-accordion-title>{{ 'Rangier-/Sperrsignale' | mrTranslate }}</clr-accordion-title>
                    <clr-accordion-content *clrIfExpanded>
                      <div class="btn-group btn-icon" style="display: flow">
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(28, $event)"
                          title="{{ 'Lichtsperrsignal' | mrTranslate }}">
                          <cds-icon shape="styp28" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(27, $event)"
                          title="{{ 'Lichtsperrsignal mit niedrigem Mast' | mrTranslate }}">
                          <cds-icon shape="styp27" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(24, $event)"
                          title="{{ 'Rangerhalttafel' | mrTranslate }}">
                          <cds-icon shape="styp24" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(43, $event)"
                          title="{{ 'Sh12/Ra12' | mrTranslate }}">
                          <cds-icon shape="styp43" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(44, $event)"
                          title="{{ 'Wartezeichen' | mrTranslate }}">
                          <cds-icon shape="styp44" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(45, $event)"
                          title="{{ 'Wartezeichen mit SH1' | mrTranslate }}">
                          <cds-icon shape="styp45" size="30" />
                        </button>
                      </div>
                    </clr-accordion-content>
                  </clr-accordion-panel>
                  <clr-accordion-panel>
                    <clr-accordion-title>{{ 'Kabellagepläne' | mrTranslate }}</clr-accordion-title>
                    <clr-accordion-content *clrIfExpanded>
                      <div class="btn-group btn-icon" style="display: flow">
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(38, $event)"
                          title="{{ 'Kabelschrank' | mrTranslate }}">
                          <cds-icon shape="styp38" size="38" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(39, $event)"
                          title="{{ 'Schalthaus' | mrTranslate }}">
                          <cds-icon shape="styp39" size="39" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(40, $event)"
                          title="{{ 'Kabelverteiler' | mrTranslate }}">
                          <cds-icon shape="styp40" size="40" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(41, $event)"
                          title="{{ 'Kabelschacht' | mrTranslate }}">
                          <cds-icon shape="styp41" size="41" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(42, $event)"
                          title="{{ 'Weichenantrieb' | mrTranslate }}">
                          <cds-icon shape="styp42" size="42" />
                        </button>
                      </div>
                    </clr-accordion-content>
                  </clr-accordion-panel>
                  <clr-accordion-panel>
                    <clr-accordion-title>{{ 'Sonstige' | mrTranslate }}</clr-accordion-title>
                    <clr-accordion-content *clrIfExpanded>
                      <div class="btn-group btn-icon" style="display: flow">
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(10, $event)"
                          title="{{ 'Andreaskreuz' | mrTranslate }}">
                          <cds-icon shape="styp10" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(11, $event)"
                          title="{{ 'Überwachungssignal' | mrTranslate }}">
                          <cds-icon shape="styp11" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(12, $event)"
                          title="{{ 'Andreaskreuz mit Lichtzeichen' | mrTranslate }}">
                          <cds-icon shape="styp12" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(13, $event)"
                          title="{{ 'Beleuchtung' | mrTranslate }}">
                          <cds-icon shape="styp13" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(9, $event)"
                          title="{{ 'Andreaskreuz (liegend)' | mrTranslate }}">
                          <cds-icon shape="styp9" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(29, $event)"
                          title="{{ 'Schrankenanlage' | mrTranslate }}">
                          <cds-icon shape="styp29" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(5, $event)"
                          title="{{ 'Gleisabschluss' | mrTranslate }}">
                          <cds-icon shape="styp5" size="30" />
                        </button>
                        <button
                          type="button"
                          class="btn btn-icon"
                          (click)="startPlaceSymbol(46, $event)"
                          title="{{ 'Haltestelle' | mrTranslate }}">
                          <cds-icon shape="styp46" size="30" />
                        </button>
                      </div>
                    </clr-accordion-content>
                  </clr-accordion-panel>
                </clr-accordion>
              </clr-accordion-content>
            </clr-accordion-panel>
            <clr-accordion-panel>
              <clr-accordion-title>{{ 'Import' | mrTranslate }} / {{ 'Export' | mrTranslate }}</clr-accordion-title>
              <clr-accordion-content *clrIfExpanded>
                <clr-dropdown>
                  <button clrDropdownTrigger>
                    <cds-icon size="22" shape="folder-open" />
                    <cds-icon shape="angle" direction="down" />
                  </button>
                  <clr-dropdown-menu *clrIfOpen clrPosition="top-left">
                    <clr-dropdown>
                      <a clrDropdownTrigger>
                        <cds-icon shape="import" size="22" />
                        {{ 'Import' | mrTranslate }}
                      </a>
                      <clr-dropdown-menu *clrIfOpen clrPosition="top-left">
                        <a (click)="fileInput.click()" clrDropdownItem>
                          <cds-icon shape="importOSM" size="22" />
                          {{ 'OSM Datei' | mrTranslate }}
                        </a>

                        <a (click)="openShpModal()" clrDropdownItem>
                          <cds-icon shape="importSHP" size="22" />
                          {{ 'SHP Datei' | mrTranslate }}
                        </a>

                        <!-- <a (click)="fileInputSHP.click()" clrDropdownItem>
                          <cds-icon shape="importSHP" size="22" />
                          {{ 'SHP Datei' | mrTranslate }}
                        </a> -->

                        <a (click)="fileInpuKMZ.click()" clrDropdownItem>
                          <cds-icon shape="importKMZ" size="22" />
                          {{ 'KMZ Datei' | mrTranslate }}
                        </a>
                        <a (click)="fileInputALKIS.click()" clrDropdownItem>
                          <cds-icon shape="importALKIS" size="22" />
                          {{ 'ALKIS Datei' | mrTranslate }}
                        </a>
                        <a (click)="fileInputdxf.click()" clrDropdownItem>
                          <cds-icon shape="importDXF" size="22" />
                          {{ 'DXF Datei' | mrTranslate }}
                        </a>
                        <a (click)="fileInputGPKG.click()" clrDropdownItem>
                          <cds-icon shape="importGPKG" size="22" />
                          {{ 'GPKG Datei' | mrTranslate }}
                        </a>
                        <a (click)="fileInputGeoJson.click()" clrDropdownItem>
                          <cds-icon shape="importGeoJson" size="22" />
                          {{ 'GeoJson Datei' | mrTranslate }}
                        </a>

                        <!-- <a (click)="fileInputCSV.click()" clrDropdownItem>
                          <cds-icon shape="csv" size="22" />
                          {{ 'CSV Datei' | mrTranslate }}
                        </a> -->

                        <a (click)="fileInpuMRpro.click()" clrDropdownItem>
                          <cds-icon shape="importMRpro" size="22" />
                          {{ 'MRpro GISMAP Datei' | mrTranslate }}
                        </a>
                      </clr-dropdown-menu>
                    </clr-dropdown>
                    <clr-dropdown>
                      <button clrDropdownTrigger [disabled]="curentGeoJson == undefined">
                        <cds-icon shape="export" size="22" />
                        {{ 'Export' | mrTranslate }}
                      </button>
                      <clr-dropdown-menu *clrIfOpen clrPosition="top-left">
                        <a (click)="generateDownloadUri('Json')" clrDropdownItem>
                          <cds-icon shape="exportjson" size="22" />
                          {{ 'GEOJSON Datei' | mrTranslate }}
                        </a>
                        <a (click)="generateDownloadUri('DXF')" clrDropdownItem>
                          <cds-icon shape="exportdxf" size="22" />
                          {{ 'DXF Datei' | mrTranslate }}
                        </a>
                        <a (click)="generateDownloadUri('pdf')" clrDropdownItem>
                          <cds-icon shape="exportpdf" size="22" />
                          {{ 'PDF Datei' | mrTranslate }}
                        </a>
                        <a (click)="generateDownloadUri('shp')" clrDropdownItem>
                          <cds-icon shape="exportshp" size="22" />
                          {{ 'SHP Datei' | mrTranslate }}
                        </a>
                        <a (click)="generateDownloadUri('kml')" clrDropdownItem>
                          <cds-icon shape="exportkml" size="22" />
                          {{ 'KML Datei' | mrTranslate }}
                        </a>
                      </clr-dropdown-menu>
                    </clr-dropdown>
                  </clr-dropdown-menu>
                </clr-dropdown>
                <input
                  type="file"
                  #fileInput
                  id="fileInput"
                  name="fileInput"
                  style="display: none; max-height: 200px"
                  (change)="onFileOSMChange($event)" />
                <input
                  type="file"
                  #fileInputSHP
                  id="fileInputSHP"
                  accept=".zip"
                  name="fileInputSHP"
                  style="display: none; max-height: 200px"
                  (change)="onFileSHPChange($event)" />
                <input
                  type="file"
                  #fileInputALKIS
                  id="fileInputALKIS"
                  accept=".zip"
                  name="fileInputALKIS"
                  style="display: none; max-height: 200px"
                  (change)="onFileALKISChange($event)" />
                <input
                  type="file"
                  #fileInputdxf
                  id="fileInputdxf"
                  accept=".dxf"
                  name="fileInputdxf"
                  style="display: none; max-height: 200px"
                  (change)="onFileDXFChange($event)" />
                <input
                  type="file"
                  #fileInputGPKG
                  id="fileInputGPKG"
                  accept=".gpkg"
                  name="fileInputGPKG"
                  style="display: none; max-height: 200px"
                  (change)="onFileGPKGChange($event)" />
                <input
                  type="file"
                  #fileInputGeoJson
                  id="fileInputGeoJson"
                  accept=".geojson"
                  name="fileInputGeoJson"
                  style="display: none; max-height: 200px"
                  (change)="onFileGeoJSONChange($event)" />
                <input
                  type="file"
                  #fileInputCSV
                  id="fileInputCSV"
                  accept=".csv"
                  name="fileInputCSV"
                  style="display: none; max-height: 200px"
                  (change)="onFileCSVChange($event)" />
                <input
                  type="file"
                  #fileInpuMRpro
                  id="fileInpuMRpro"
                  accept=".mrgis"
                  name="fileInpuMRpro"
                  style="display: none; max-height: 200px"
                  (change)="onFileMRproChange($event)" />
                <input
                  type="file"
                  #fileInpuKMZ
                  id="fileInpuKMZ"
                  accept=".kmz"
                  name="fileInpuKMZ"
                  style="display: none; max-height: 200px"
                  (change)="onFileKMZChange($event)" />
                <br />
                <clr-select-container>
                  <label>{{ 'Projektionstyp' | mrTranslate }}:</label>
                  <select clrSelect name="options" #mySelect (change)="EPSGChanged(mySelect.value)">
                    <option value="EPSG:4326">EPSG 4326 WGS 84 World</option>
                    <option value="EPSG:2169">EPSG 2169 Luxembourg 1930 / Gauss</option>
                    <option value="EPSG:2056">EPSG 2056 Swiss CH1903 + / LV95</option>
                    <option value="EPSG:21781">EPSG 21781 Swiss CH1903 / LV03</option>
                    <option value="EPSG:25831">EPSG 25831 ETRS89 / UTM zone 31N</option>
                    <option value="EPSG:25832">EPSG 25832 ETRS89 / UTM zone 32N</option>
                    <option value="EPSG:25833">EPSG 25833 ETRS89 / UTM zone 33N</option>
                    <option value="EPSG:31466">EPSG 31466 Gauss-Kruger Zone 2 (Mittelmeridiane 6 Grad)</option>
                    <option value="EPSG:31467">EPSG 31467 Gauss-Kruger Zone 3 (Mittelmeridiane 9 Grad)</option>
                    <option value="EPSG:31468">EPSG 31468 Gauss-Kruger Zone 4 (Mittelmeridiane 12 Grad)</option>
                    <option value="EPSG:31469">EPSG 31469 Gauss-Kruger Zone 5 (Mittelmeridiane 15 Grad)</option>
                    <option value="EPSG:31370">EPSG 31370 Belge 1972 / Belgian Lambert 72</option>
                  </select>
                </clr-select-container>
              </clr-accordion-content>
            </clr-accordion-panel>
          </clr-accordion>
          <br />
          <button
            class="btn btn-primary"
            [disabled]="tempfeaturesList.length == 0 && !enableSave"
            (click)="saveFeatures()">
            {{ 'Speichern' | mrTranslate }}
          </button>
        }
      </div>
    }

    <!-- Spezielle Replikat-Funktionen -->
    @if (isRep) {
      <clr-checkbox-wrapper class="map-option-check">
        <label>{{ 'Standort anzeigen' | mrTranslate }}</label>
        <input type="checkbox" clrCheckbox value="1" (click)="showPosition($event)" />
      </clr-checkbox-wrapper>

      <clr-checkbox-wrapper class="map-option-check">
        <label>{{ 'Nur Objekte im Replikat angezeigen' | mrTranslate }}</label>
        <input type="checkbox" clrCheckbox value="1" (change)="switchRepFilter($event)" />
      </clr-checkbox-wrapper>
    }
  </div>

  <div id="overlaySwitcherTriggerWrapper">
    <div id="overlaySwitcherTrigger" class="cursor-pointer" (click)="triggerOverlaySwitcher()">
      <a href="javascript:void(0);">
        <cds-icon size="32" shape="angle-double" [direction]="showOverlaySwitcher ? 'left' : 'right'" />
      </a>
    </div>
  </div>
  <div
    id="mapWrap"
    [ngClass]="{
      showprogressbar: showprogressbar && progressbarenlarged,
      split50: split50 && !hidedetailview,
      showdetailview: showdetailview && !hidedetailview,
    }">
    <div style="height: 100%" id="map-page">
      <div #popup class="ol-popup"></div> 
      <div id="map" class="map">
        <div id="feature-menu" class="feature-menu"></div>
        <div #info id="info" [style]="infoStyle()" [innerHTML]="infoHTML()"></div>
        <div #position id="position" [style]="posStyle()" [innerHTML]="posHTML()"></div>      
      </div>
    </div>
  </div>
  @if (showdetailview) {
    <div #dvwrapper id="wrapperdetailview" [ngClass]="{ sidenavenlarged, split50, hidedetailview }">
      <app-detailview
        [rechte]="rechte"
        [ostammid]="ostammid"
        [progressbarenlarged]="progressbarenlarged"
        [split50]="split50"
        [expanded]="sidenavenlarged"
        [hidden]="hidedetailview"
        (gispos)="setGisPos($event)"
        (enlarge)="enlargeSidenav($event)"
        (enlargePB)="enlargeProgressbar(true)"
        (progressData)="showProgressData($event)"
        (indexScrub)="handleScrub($event)"
        (reload)="reloadDetailview()"
        #detailView></app-detailview>
    </div>
  }
</div>

@if (showprogressbar) {
  <div id="progresstrigger" [class.bottom]="!progressbarenlarged">
    <div class="wrap" (click)="enlargeProgressbar()">
      <cds-icon
        shape="angle"
        [direction]="progressbarenlarged ? 'down' : 'up'"
        class="expandProgressbarButton cursor-pointer" />
    </div>
  </div>
  @if (progressbarenlarged) {
    <footer id="wrapperprogressbars" class="clr-row nxm clr-align-items-center">
      <app-progressbar
        [dataIn]="progressbars"
        [indexScrub]="indexScrub"
        (enlargeProgressbar)="enlargeProgressbar(true)"
        (barclicked)="setBarclicked($event)"
        (contextMenuClicked)="setContextMenuClicked($event)"
        (barMouseOver)="setBarMouseOver($event)"
        (barMouseLeave)="setBarMouseLeave($event)"
        style="display: inline-block; width: calc(100% - 35px)" />
    </footer>
  }
  
}

<!-- MODAL SHP FILE IMPORT -->
<clr-modal [(clrModalOpen)]="modalOpenShp" [clrModalSize]="'md'" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'SHP Datei importieren' | mrTranslate }}</h3>

  <div class="modal-body">
    <a class="clickable" (click)="fileInputSHP.click()">
      <cds-icon shape="importSHP" size="22" />
      {{ 'SHP Datei auswählen: ' | mrTranslate }} {{ selectedShpFileName() }}
    </a>

    <input
      type="file"
      #fileInputSHP
      id="fileInputSHP"
      accept=".zip"
      name="fileInputSHP"
      style="display: none; max-height: 200px"
      (change)="onShpFileSelected($event)" />

    @if (selectedShpFileName() !== '') {
      <form clrForm clrLayout="horizontal" [formGroup]="modalShpLink">
        <clr-select-container>
          <label>{{ 'Objekttyp' | mrTranslate }}</label>
          <select
            clrSelect
            name="options"
            formControlName="objTyp"
            #mySelectTyp
            (change)="objShpTypChanged(+mySelectTyp.value)">
            @for (objlist of tblshpObjektTypen; track objlist) {
              <option value="{{ objlist.ID }}">
                {{ objlist.Bezeichnung }}
              </option>
            }
          </select>
        </clr-select-container>

        @if (dbfFields() && this.curShpObjTyp() > 0) {
          @if (this.curShpObjTyp() == 1) {
            <table class="table">
              <thead>
                <tr>
                  <th>{{ 'SHP' | mrTranslate }} {{ 'Feld' | mrTranslate }}</th>
                  <th>{{ 'MR.pro' | mrTranslate }} {{ 'Feld' | mrTranslate }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (row of matchRows(); track $index) {
                  <tr>
                    <td>
                      <select
                        clrSelect
                        [value]="row.shpField ?? ''"
                        (change)="updateShp($index, $any($event.target).value)"
                        [class.is-invalid]="isDuplicateShp(row.shpField, $index)">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of dbfFields(); track field) {
                          <option [value]="field.name">
                            {{ field.name }}
                          </option>
                        }
                      </select>
                      @if (isDuplicateShp(row.shpField, $index)) {
                        <div class="validation-error">
                          {{ 'Feld wird bereits verwendet' | mrTranslate }}
                        </div>
                      }
                    </td>
                    <td>
                      <select
                        clrSelect
                        [value]="row.mrField ?? ''"
                        (change)="updateMr($index, $any($event.target).value)"
                        [class.is-invalid]="isDuplicateMr(row.mrField, $index)">
                        <option value="">-- {{ 'auswählen' | mrTranslate }} --</option>

                        @for (field of stammdaten; track field) {
                          <option [value]="field.FeldName">
                            {{ field.Bezeichnung }}
                          </option>
                        }
                      </select>

                      @if (isDuplicateMr(row.mrField, $index)) {
                        <div class="validation-error">
                          {{ 'Feld wird bereits verwendet' | mrTranslate }}
                        </div>
                      }
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-icon"
                        (click)="removeRow($index)"
                        [disabled]="matchRows().length === 1">
                        ✕
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <button type="button" class="btn btn-primary" (click)="addRow()">
              + {{ 'Zeile hinzufügen' | mrTranslate }}
            </button>
          } @else {
            <clr-select-container>
              <label>{{ lableShpSync() | mrTranslate }}</label>
              <select clrSelect name="options" formControlName="Field" #mySelectField>
                @for (fieldlist of dbfFields(); track fieldlist) {
                  <option value="{{ fieldlist.name }}">
                    {{ fieldlist.name }}
                  </option>
                }
              </select>
            </clr-select-container>
          }
        }
      </form>
      <br />
      <br />
    }
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!selectedShpFile() || hasDuplicates() || curShpObjTyp() === -1"
      (click)="importShpFile()">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="closeShpModal()">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<!-- MODAL OBJEKTVERKNÜPFUNG -->
<clr-modal [(clrModalOpen)]="isObjLinkVisible" [clrModalSize]="'xl'" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Objekt verknüpfen' | mrTranslate }}</h3>
  @if (tblObjektTypen) {
    <div class="modal-body">
      <form clrForm clrLayout="horizontal" [formGroup]="modalLinkGroup">
        <clr-select-container style="margin-top: -12px">
          <label>{{ 'Objekttyp' | mrTranslate }}</label>
          <select clrSelect name="options" formControlName="objTyp" #mySelect (change)="objTypChanged(+mySelect.value)">
            @for (objlist of tblObjektTypen.rows; track objlist) {
              <option value="{{ objlist.ID }}">
                {{ objlist.Bezeichnung }}
              </option>
            }
          </select>
        </clr-select-container>
        @if (tblAnl) {
          <div>
            <clr-datagrid
              [clrDgSelectionType]="'single'"
              [clrDgSelected]="[selTbl]"
              (clrDgSelectedChange)="selTbl = $event[0]"
              [clrDgItemsIdentityFn]="row => row?.OSTAMMID"
              class="datagrid-compact"
              style="height: 50vh">
              @for (column of tblAnl.columns; track column) {
                <clr-dg-column [clrDgField]="column.id">
                  <clr-dg-filter [attr.data-test-id]="'datagrid-anlagen-col-filter-' + column.id">
                    <app-column-filter
                      tableName="anlagen"
                      [column]="column"
                      [objektTypIconValue]="tableIconColumnValues"
                      [uniqueColumnValues]="getUniqueValuesForColumn(tableUniqueColumnValues, column.id)"
                      (changes)="onFilterChange($event)" />
                  </clr-dg-filter>
                  <ng-container
                    *clrDgHideableColumn="{
                      hidden: column.id | hideIDColumns: ['bildpfad', 'lf', 'st', 'sp', 'rep', 'messreg bezirk'],
                    }">
                    {{ column.id | mrTranslate | titlecase }}
                  </ng-container>
                </clr-dg-column>
              }
              <ng-template
                clrVirtualScroll
                let-row
                [clrVirtualRowsOf]="filteredRows"
                [clrVirtualRowsMaxBufferPx]="3000"
                [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID">
                <clr-dg-row [clrDgItem]="row">
                  @for (cell of tblAnl.columns; track cell) {
                    <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                  }
                </clr-dg-row>
              </ng-template>
              <clr-dg-footer>{{ filteredRows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>
          </div>
        }
      </form>
    </div>
  }
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="editFeature()">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="isObjLinkVisible = false">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<!-- MODAL POSITION -->
<clr-modal [(clrModalOpen)]="isPositionModalVisible" [clrModalSize]="'m'" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Position angeben' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="horizontal" [formGroup]="modalCutEditor">
      <div>Geben Sie die Position (m) ein, in der geschnitten werden soll:</div>
      <br />
      <input
        type="number"
        min="0"
        max="{{ featLen }}"
        style="width: 250px"
        formControlName="PositionCut"
        id="PositionCut"
        class="clr-input" />
      <label id="lblLaenge" style="margin-left: 20px">{{ 'Gleislänge:' | mrTranslate }} {{ featLen }} m</label>
      <br />
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="cutLine(-1)">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="isPositionModalVisible = false">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<!-- MODAL KARTENSET NAME -->
<clr-modal [(clrModalOpen)]="isMapSetNameVisible" [clrModalSize]="'m'" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Name angeben' | mrTranslate }}</h3>
  <div class="modal-body">
    <label>Tragen Sie den Namen dieses Kartensets ein</label>
    <br />
    <input type="text" style="width: 250px" [(ngModel)]="SetName" class="clr-input" />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="createMapSet()">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="isMapSetNameVisible = false">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<!-- MODAL GEOPOSITION ANZEIGEN -->
<clr-modal [(clrModalOpen)]="isGeoPosModalVisible" [clrModalSize]="'m'" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Geoposition' | mrTranslate }}</h3>
  <div class="modal-body">
    @if (!arcShowDlgOnly) {
      <div>
        @if (measure.SetSecondPoint) {
          <div>
            <label>{{ 'Position 1:' | mrTranslate }}</label>
            <br />
            <label style="margin-left: 20px">in m: {{ measure.Point1 }}</label>
            <br />
            <label style="margin-left: 20px">in °: {{ measure.Point1_Deg }}</label>
            <br />
            <label>{{ 'Position 2:' | mrTranslate }}</label>
            <br />
            <label style="margin-left: 20px">in m: {{ measure.Point2 }}</label>
            <br />
            <label style="margin-left: 20px">in °: {{ measure.Point2_Deg }}</label>
            <br />
            <br />
            <label>{{ 'Abstand X:' | mrTranslate }}</label>
            {{ measure.PointX }}
            <br />
            <label>{{ 'Abstand Y:' | mrTranslate }}</label>
            {{ measure.PointY }}
            <br />
            <label>{{ 'Abstand:' | mrTranslate }}</label>
            {{ measure.Distance }}
          </div>
        } @else {
          <label>{{ 'Aktuelle Geopositon:' | mrTranslate }}</label>
          <br />
          <input
            type="text"
            style="width: 350px"
            value="{{ mouseposConv }}"
            #GeoPosMove
            id="GeoPosMove"
            class="clr-input" />
        }
      </div>
    } @else {
      <label>{{ 'Radius:' | mrTranslate }}</label>
      <br />
      <input type="text" style="width: 350px" value="{{ dlgRadius }}" #GeoPosMove id="GeoPosMove" class="clr-input" />
    }
  </div>
  <!-- <div class="modal-footer">
                                                                                          <button type="button" class="btn btn-primary" (click)="moveToPos()">{{'OK' | mrTranslate}}</button>
                                                                                          <button type="button" class="btn" (click)="isGeoPosModalVisible = false">{{'Abbrechen' | mrTranslate}}</button>
                                                                                        </div> -->
</clr-modal>

<!-- MODAL WEICHENEDITOR -->
<clr-modal [(clrModalOpen)]="isTurnoutEditorVisible" [clrModalSize]="'xl'" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Weicheneditor' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="horizontal" [formGroup]="modalTOEditor">
      <div class="container">
        <label>{{ 'Weichentyp' | mrTranslate }}</label>
        <select
          name="options"
          style="margin-top: 0px"
          formControlName="WeichenTyp"
          #mySelect
          (change)="getTOData(mySelect.value)">
          @for (objlist of lstWeichenTypen | keyvalue; track objlist) {
            <option [selected]="objlist.key === 0" [value]="objlist.key">
              {{ objlist.value }}
            </option>
          }
        </select>
        <div class="clr-radio-wrapper">
          <input
            type="radio"
            id="rbL"
            style="left: 15px"
            clrRadio
            [value]="0"
            formControlName="richtung"
            (change)="switchDir()" />
          <label class="clr-col-md-6">{{ 'Links' | mrTranslate }}</label>
        </div>
        <div class="clr-radio-wrapper">
          <input
            type="radio"
            id="rbR"
            style="left: 15px"
            clrRadio
            [value]="1"
            formControlName="richtung"
            (change)="switchDir()" />
          <label for="A2" class="clr-col-md-12">{{ 'Rechts' | mrTranslate }}</label>
        </div>
      </div>
      <div class="container" style="margin-top: 10px">
        <label style="margin-top: 12px">{{ 'Bezeichnung' | mrTranslate }}</label>
        <select name="options" formControlName="Bezeichnung" #mySelect2 (change)="setTOTypes(mySelect2.value)">
          @for (objlist of lstWeichen; track objlist) {
            <option value="{{ objlist }}">{{ objlist }}</option>
          }
        </select>
        <button
          class="btn-outline"
          (click)="TOEditorCreateTO($event)"
          title="{{ 'Eigene Weiche erstellen' | mrTranslate }}">
          <cds-icon shape="add" size="32" />
        </button>
        <button class="btn-outline" (click)="TOEditorDeleteTO($event)" title="{{ 'Weiche löschen' | mrTranslate }}">
          <cds-icon shape="delete" size="32" />
        </button>
        <button class="btn-outline" (click)="TOEditorEditTO($event)" title="{{ 'Weiche Bearbeiten' | mrTranslate }}">
          <cds-icon shape="pencil" size="32" />
        </button>
        <input
          type="text"
          id="BezPosition"
          formControlName="BezPosition"
          placeholder="Bezeichnung neue Schiene"
          style="width: 200px"
          class="clr-input" />
      </div>
      <br />
      <div class="container">
        <label>{{ 'Position' | mrTranslate }}</label>
        <input type="text" formControlName="Position" class="clr-input" />
        <input type="checkbox" formControlName="PositionCut" />
        <label>{{ 'Gleis an Position schneiden' | mrTranslate }}</label>
        <input type="checkbox" formControlName="PositionMouse" />
        <label>{{ 'Im gewählten Gleis an Mausposition setzen' | mrTranslate }}</label>
      </div>
      <br />
      <div class="clr-row" style="margin-top: 30px">
        <div class="clr-col-12">
          <div style="border-style: solid">
            <div class="clr-row">
              <div style="min-height: 300px; max-height: 300px">
                <img [src]="curTOPic" alt="" style="max-height: 296px; width: 700px" class="uploadImagePreview" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <input
        type="text"
        [ngModel]="tb1()"
        [ngModelOptions]="{ standalone: true }"
        [style]="tb1Style()"
        class="clr-input tbstandard"
        value="0"
        (change)="changeTB(tb1, $event)" />
      <input
        type="text"
        [ngModel]="tb2()"
        [ngModelOptions]="{ standalone: true }"
        [style]="tb2Style()"
        class="clr-input tbstandard"
        value="0"
        (change)="changeTB(tb2, $event)" />
      <input
        type="text"
        [ngModel]="tb3()"
        [ngModelOptions]="{ standalone: true }"
        [style]="tb3Style()"
        class="clr-input tbstandard"
        value="0"
        (change)="changeTB(tb3, $event)" />
      <input
        type="text"
        [ngModel]="tb4()"
        [ngModelOptions]="{ standalone: true }"
        [style]="tb4Style()"
        class="clr-input tbstandard"
        value="0"
        (change)="changeTB(tb4, $event)" />
      <input
        type="text"
        [ngModel]="tb5()"
        [ngModelOptions]="{ standalone: true }"
        [style]="tb5Style()"
        class="clr-input tbstandard"
        value="0"
        (change)="changeTB(tb5, $event)" />
      <input
        type="text"
        [ngModel]="tb6()"
        [ngModelOptions]="{ standalone: true }"
        [style]="tb6Style()"
        class="clr-input tbstandard"
        value="0"
        (change)="changeTB(tb6, $event)" />
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="startPlaceTOSymbol($event)">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="isTurnoutEditorVisible = false">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<!-- MODAL FEHLERFILTER -->
<clr-modal [(clrModalOpen)]="isFehlerFilterVisible" [clrModalSize]="'xl'" [clrModalClosable]="true">
  <h3 class="modal-title">
    {{ 'Datenfilter nach Eigenschaft' | mrTranslate }}
  </h3>
  <div class="modal-body">
    @if (filterSelection.length == 0) {
      <div styple="position: relative; width:100%; margin: auto; text-align: center;">
        <span class="spinner spinner-md">Loading...</span>
      </div>
    } @else {
      <form clrForm clrLayout="horizontal" [formGroup]="modalFKFilter">
        <div class="clr-row">
          <div class="clr-col-4">
            <clr-select-container style="margin-top: 0px">
              <label for="stamm">{{ 'Type' | titlecase | mrTranslate }}</label>
              <select
                clrSelect
                formControlName="tabelle"
                name="tabelle"
                #filterSelect
                (change)="setFilterWerte(filterSelect.value)">
                <option [value]="0" disabled></option>
                @for (obj of filterSelection | keyvalue; track obj) {
                  <option [value]="obj.key">
                    {{ obj.value.anzeige }}
                  </option>
                }
              </select>
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
              </clr-control-error>
            </clr-select-container>
          </div>
          <div class="clr-col-4">
            <clr-datalist-container style="margin-top: 0px; margin-left: -50px">
              <label for="wert">{{ 'Wert' | titlecase | mrTranslate }}</label>
              <input
                clrDatalistInput
                type="search"
                autocomplete="off"
                formControlName="wert"
                name="wert"
                style="min-width: 600px" />
              <datalist>
                @for (obj of filterWerteListe; track obj) {
                  <option [value]="obj">
                    {{ obj }}
                  </option>
                }
              </datalist>
              <clr-control-error *clrIfError="'required'">
                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
              </clr-control-error>
            </clr-datalist-container>
          </div>
          <div class="clr-col-1">
            <div class="clr-radio-wrapper">
              <input type="radio" id="rbL" style="left: 28px" clrRadio [value]="0" formControlName="operators" />
              <label class="clr-col-md-6">{{ '=' | mrTranslate }}</label>
            </div>
          </div>
          <div class="clr-col-1">
            <div class="clr-radio-wrapper">
              <input type="radio" id="rbR" style="left: 28px" clrRadio [value]="1" formControlName="operators" />
              <label for="A2" class="clr-col-md-6">{{ 'enthält' | mrTranslate }}</label>
            </div>
          </div>
          <div class="clr-col-2">
            <button style="margin-top: -5px" type="button" class="btn btn-primary btn-icon" (click)="addFilter()">
              <cds-icon shape="plus" />
            </button>
          </div>
        </div>
      </form>
      <div style="min-height: 5px"></div>

      @if (sqlfilter.length == 0) {
        <div>
          <span>{{ 'aktiver Filter' | mrTranslate }}:</span>
        </div>
      } @else {
        <span>{{ 'aktiver Filter' | mrTranslate }}: {{ 'Objekte' | mrTranslate }} = {{ filterItems.length }}</span>
      }

      <div class="flex-container">
        <br />
        @for (item of sqlfilter; track item) {
          <span class="label label-info" style="min-height: 28px">
            {{ item.sql }}
            <cds-icon
              shape="times"
              class="cursor-pointer"
              (click)="delete(item)"
              style="margin-left: 0.5rem; margin-right: -0.25rem" />
          </span>
        }
      </div>
    }
  </div>
  <div class="modal-footer">
    @if (sqlfilter.length != 0) {
      <button type="button" class="btn btn-primary" (click)="activateFilter()">
        {{ 'OK' | mrTranslate }}
      </button>
    }
    <button type="button" class="btn" (click)="cancelFilter()">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<!-- MODAL ALKIS Import -->
<clr-modal [(clrModalOpen)]="isALKISImportVisible" [clrModalSize]="'xl'" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'ALKIS-Nas Import' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="horizontal" [formGroup]="modalAlkis">
      <div class="clr-row">
        <div class="clr-col-1">
          <label>{{ 'Datei' | titlecase | mrTranslate }}</label>
        </div>
        <div class="clr-col-11">
          <label>{{ alkis_file_name }}</label>
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-1">
          <label>{{ 'Objekttyp' | titlecase | mrTranslate }}</label>
        </div>
        <div class="clr-col-6">
          <div class="clr-form-horizontal">
            @if (objekte(); as objekte) {
              <clr-select-container style="margin-top: 0px">
                <label style="width: auto; padding: 0 25px">
                  @if (objekte[otypid()]?.symbol; as symbol) {
                    <cds-icon style="color: #000" class="grid-icon" [shape]="'objekttyp' + symbol" size="22" />
                  }
                </label>
                <select
                  clrSelect
                  name="objekt"
                  style="margin-left: -45px; width: 335px"
                  [(ngModel)]="otypid"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="changeALKISTyp($event)">
                  @for (typ of objekte | keyvalue; track typ.key) {
                    <option [ngValue]="+typ.key">
                      {{ typ.value.bezeichnung }}
                    </option>
                  }
                </select>
              </clr-select-container>
            } @else {
              <clr-spinner [clrSmall]="true" />
            }
          </div>
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-1">
          <label>{{ 'Schlüsselfeld' | titlecase | mrTranslate }}</label>
        </div>
        <div class="clr-col-6">
          <clr-select-container style="margin-top: 0px; margin-left: -70px">
            <select clrSelect formControlName="schluessel" name="schluessel" #schluessel (change)="alkisHeaderChange()">
              @for (obj of alkis_fields; track obj) {
                <option [value]="obj">
                  {{ obj }}
                </option>
              }
            </select>
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
          </clr-select-container>
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-1">
          <label>{{ 'Bezeichnung' | titlecase | mrTranslate }}</label>
        </div>
        <div class="clr-col-6">
          <clr-select-container style="margin-top: 0px; margin-left: -70px">
            <select clrSelect formControlName="name" name="name" #name (change)="alkisHeaderChange()">
              @for (obj of alkis_fields; track obj) {
                <option [value]="obj">
                  {{ obj }}
                </option>
              }
            </select>
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
          </clr-select-container>
        </div>
      </div>
      <br />
      <div class="clr-row">
        <div class="clr-col-1">
          <label>{{ 'Feldzuordnung' | titlecase | mrTranslate }}</label>
        </div>
        <div class="clr-col-10">
          <div class="limit-height">
            @if (alkis.length) {
              <clr-datagrid class="datagrid-compact" style="padding-top: 0px; margin-left: 40px">
                <clr-dg-column>Nas-Key</clr-dg-column>
                <clr-dg-column>MR.pro Feld</clr-dg-column>

                <clr-dg-row *clrDgItems="let row of alkis" [clrDgItem]="row">
                  <clr-dg-cell>{{ row['NASKeyName'] }}</clr-dg-cell>

                  <clr-dg-cell>
                    <clr-select-container style="margin-top: 0px; margin-left: -110px">
                      <select
                        clrSelect
                        style="width: 300px"
                        [(ngModel)]="row['SFELDNA']"
                        [ngModelOptions]="{ standalone: true }">
                        @for (option of alkis_spez | keyvalue; track option.key) {
                          <option [value]="option.key">
                            {{ option.value }}
                          </option>
                        }
                      </select>
                    </clr-select-container>
                  </clr-dg-cell>
                </clr-dg-row>
              </clr-datagrid>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    @if (uploadprocessrun == true) {
      <clr-progress-bar
        [clrValue]="uploadprocessprogress()"
        clrLabeled
        style="margin-top: 10px; width: 70%"></clr-progress-bar>
      <span style="margin-top: 5px; width: 100px">{{ spinnertitel() }}</span>
    }

    @if (hasAlkisHeader == true) {
      <button type="button" class="btn btn-primary" (click)="startAlkisImport()">
        {{ 'Import' | mrTranslate }}
      </button>
    }
    <button type="button" class="btn" (click)="cancelALKISImport()">
      {{ 'Beenden' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<!-- MODAL PROFILVIEWER -->
<clr-modal [(clrModalOpen)]="isProfielViewerVisible" [clrModalSize]="'full-screen'" [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Profil-Viewer' | mrTranslate }}</h3>
  <div class="modal-body">
    <div class="clr-row" style="margin-left: 10px">
      <div class="clr-col-6">
        <div>
          {{ 'Position [mil]' | mrTranslate }}: {{ pos }} ({{ pos_m }} m) | {{ 'Spurweite' | mrTranslate }}:
          {{ spur }} | {{ 'Schienenprofil' | mrTranslate }}: {{ profil }}
        </div>
      </div>
      <div class="clr-col-6">
        <div class="btn-group btn-outline-primary btn-sm btn-icon" style="margin-left: -20px">
          <button class="btn">
            <cds-icon shape="angle" direction="left" (click)="moveProfileView('left')"></cds-icon>
            <span class="clr-icon-title">Back</span>
          </button>
          <button class="btn">
            <cds-icon shape="angle" direction="right" (click)="moveProfileView('right')"></cds-icon>
            <span class="clr-icon-title">Next</span>
          </button>
        </div>
      </div>
    </div>
    <div class="clr-row" style="margin-left: 10px">
      <div class="clr-col-6">
        <div>{{ 'Distance Gauge Corner' | mrTranslate }} {{ disfk_l }}</div>
      </div>
      <div class="clr-col-6">
        <div style="margin-left: -20px">{{ 'Distance Gauge Corner' | mrTranslate }} {{ disfk_r }}</div>
      </div>
    </div>
    @if (graphL.show) {
      <div class="card-block" style="width: 99%">
        @if (graphL.show) {
          <div class="clr-row clr-justify-content-between w-100-p">
            <div id="plotly_Left" class="clr-col-6"></div>
            <div id="plotly_Right" class="clr-col-6"></div>
          </div>
        }
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="isProfielViewerVisible = false">
      {{ 'Beenden' | mrTranslate }}
    </button>
  </div>
</clr-modal>
